export class ImageDeleteMultipleModel {
    public imageIdList: Array<number>;
    constructor() {
        this.imageIdList = new Array<number>();
    }
}
